/**
 * A Custom CourseHorse Popup Overlay
 * for use with Google Maps
 */
define('overlay_popup',[
    'google_maps_new'
], function () {

    /**
     * A customized popup for the map
     *
     * The basis for this object was stolen from a google maps example:
     * https://developers.google.com/maps/documentation/javascript/examples/overlay-popup
     *
     * @param {!google.maps.LatLng} position
     * @param {!Element} content
     * @constructor
     * @extends {google.maps.OverlayView}
     */
    var OverlayPopup = function(position, content, displayOnDraw) {
        this.position = position;
        this.displayOnDraw = typeof displayOnDraw !== 'undefined' ? displayOnDraw : true;

        this.contentElement = document.createElement('div');
        // @todo - don't do this markup building all here...
        this.contentElement.innerHTML = '<i class="ui large salmon marker alternate icon"></i>' + content;
        this.contentElement.classList.add('popup-bubble-content');

        var pixelOffset = document.createElement('div');
        pixelOffset.classList.add('popup-bubble-anchor');
        pixelOffset.appendChild(this.contentElement);

        this.anchor = document.createElement('div');
        this.anchor.classList.add('popup-tip-anchor');
        this.anchor.appendChild(pixelOffset);

        // Optionally stop clicks, etc., from bubbling up to the map.
        this.stopEventPropagation();
    };

    OverlayPopup.prototype = Object.create(google.maps.OverlayView.prototype);

    /**
     * Called when the popup is added to the map.
     */
    OverlayPopup.prototype.onAdd = function() {
        this.getPanes().floatPane.appendChild(this.anchor);
    };

    /**
     * Called when the popup is removed from the map.
     */
    OverlayPopup.prototype.onRemove = function() {
        if (this.anchor.parentElement) {
            this.anchor.parentElement.removeChild(this.anchor);
        }
    };

    /**
     * Called when the popup needs to draw itself.
     */
    OverlayPopup.prototype.draw = function() {
        var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
        var verticalOffset = 45;

        // Hide the popup when it is far out of view.
        var display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
                ? 'block'
                : 'none';

        if (display === 'block') {
            this.anchor.style.left = divPosition.x + 'px';
            this.anchor.style.top = (divPosition.y + - verticalOffset) + 'px';
        }
        if (this.anchor.style.display !== display) {
            this.anchor.style.display = display;
        }

        // hide it when we default to hidden
        if (!this.displayOnDraw) {
            this.hide();
        }
    };

    /**
     * Stops clicks/drags from bubbling up to the map.
     */
    OverlayPopup.prototype.stopEventPropagation = function() {
        var anchor = this.anchor;
        anchor.style.cursor = 'auto';
        ['click', 'dblclick', 'contextmenu', 'wheel', 'mousedown', 'touchstart', 'pointerdown'].forEach(function(event) {
            anchor.addEventListener(event, function(e) {
                e.stopPropagation();
            });
        });
    };

    /**
     * sets a class to "highlight" the overlay as active
     */
    OverlayPopup.prototype.setActive = function() {
        if (this.anchor) {
            this.anchor.classList.add('active');
        }
    };

    /**
     * removes the highlight/active class
     */
    OverlayPopup.prototype.setInactive = function() {
        if (this.anchor) {
            this.anchor.classList.remove('active');
        }
    };

    OverlayPopup.prototype.hide = function () {
        this.anchor.style.display = 'none';
    }

    OverlayPopup.prototype.show = function () {
        this.anchor.style.display = 'block';
    }

    OverlayPopup.prototype.addListener = function (eventName, fn) {
        this.contentElement.addEventListener(eventName, fn);
    };

    OverlayPopup.prototype.removeListener = function (eventName, fn) {
        this.contentElement.removeEventListener(eventName, fn);
    };

    return OverlayPopup;
});

